import {
  ACCOUNTING_SERVICES_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
  ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
  ADVERTISING_SERVICES_INDUSTRY_GROUP,
  AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  AGENCIES_BROKERAGES_INDUSTRY_GROUP,
  AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
  ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
  AMUSEMENT_PARKS_INDUSTRY_GROUP,
  ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
  APPAREL_ACCESSORIES_INDUSTRY_GROUP,
  APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
  APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  AQUACULTURE_INDUSTRY_GROUP,
  ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
  ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
  ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
  AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
  AUTO_DEALERS_INDUSTRY_GROUP,
  AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
  AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
  AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
  BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
  BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
  BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
  BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
  BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
  BOOK_RETAILERS_INDUSTRY_GROUP,
  BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
  BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
  BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
  BUSINESS_SCHOOLS_INDUSTRY_GROUP,
  BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
  CATTLE_RANCHING_FARMING_INDUSTRY_GROUP,
  CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
  CHARTER_BUS_INDUSTRY_GROUP,
  CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
  CHILD_CARE_SERVICES_INDUSTRY_GROUP,
  CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  CLOTHING_RETAILERS_INDUSTRY_GROUP,
  COAL_MINING_INDUSTRY_GROUP,
  COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
  COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
  COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
  COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
  COMMODITY_CONTRACTS_INDUSTRY_GROUP,
  COMMODITY_EXCHANGES_INDUSTRY_GROUP,
  COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
  COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
  CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
  CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
  COURIER_DELIVERY_INDUSTRY_GROUP,
  CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
  CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
  DAIRY_MANUFACTURING_INDUSTRY_GROUP,
  DEATH_CARE_SERVICES_INDUSTRY_GROUP,
  DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
  DENTISTS_INDUSTRY_GROUP,
  DEPARTMENT_STORE_INDUSTRY_GROUP,
  DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  DESIGN_SERVICES_INDUSTRY_GROUP,
  DRINKING_PLACES_INDUSTRY_GROUP,
  DRUGS_WHOLESALERS_INDUSTRY_GROUP,
  EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
  ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  ELECTRONICS_REPAIR_INDUSTRY_GROUP,
  ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
  ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
  EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
  ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  FABRIC_MILLS_INDUSTRY_GROUP,
  FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
  FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  FIBER_YARN_MILLS_INDUSTRY_GROUP,
  FISHING_INDUSTRY_GROUP,
  FLORISTS_INDUSTRY_GROUP,
  FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
  FOREST_NURSERIES_INDUSTRY_GROUP,
  FORGING_AND_STAMPING_INDUSTRY_GROUP,
  FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
  FOUNDRIES_INDUSTRY_GROUP,
  FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
  FRUIT_AND_TREE_NUT_INDUSTRY_GROUP,
  FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
  FUEL_DEALERS_INDUSTRY_GROUP,
  FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
  FURNITURE_RETAILERS_INDUSTRY_GROUP,
  GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
  GASOLINE_STATIONS_INDUSTRY_GROUP,
  GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  GENERAL_MEDICAL_INDUSTRY_GROUP,
  GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
  GLASS_MANUFACTURING_INDUSTRY_GROUP,
  GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
  GRANTMAKING_INDUSTRY_GROUP,
  GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
  GROCERY_RETAILERS_INDUSTRY_GROUP,
  GROCERY_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
  HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
  HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
  HOD_AND_PIG_FARMING_INDUSTRY_GROUP,
  HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
  HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
  HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
  HUNTING_AND_TRAPPING_INDUSTRY_GROUP,
  INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
  INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
  INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  INSURANCE_CARRIER_INDUSTRY_GROUP,
  INSURANCE_FUNDS_INDUSTRY_GROUP,
  INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
  INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
  IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
  JEWELRY_RETAILERS_INDUSTRY_GROUP,
  JUNIOR_COLLEGES_INDUSTRY_GROUP,
  LAND_SUBDIVISION_INDUSTRY_GROUP,
  LAUNDRY_SERVICES_INDUSTRY_GROUP,
  LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
  LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
  LEGAL_SERVICES_INDUSTRY_GROUP,
  LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
  LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
  LOCAL_DELIVERY_INDUSTRY_GROUP,
  LOGGING_INDUSTRY_GROUP,
  LUMBER_WHOLESALERS_INDUSTRY_GROUP,
  MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
  MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
  MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
  MEDIA_STREAMING_INDUSTRY_GROUP,
  MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  MEDICAL_LABS_INDUSTRY_GROUP,
  METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
  METAL_ORE_MINING_INDUSTRY_GROUP,
  METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
  MOTION_PICTURE_INDUSTRY_GROUP,
  MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
  MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
  NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
  NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
  NEWSPAPER_INDUSTRY_GROUP,
  NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
  NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
  NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
  NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
  OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
  OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
  OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
  OILSEED_AND_GRAIN_INDUSTRY_GROUP,
  OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
  OTHER_AMUSEMENT_INDUSTRY_GROUP,
  OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP,
  OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_CROP_FARMING_INDUSTRY_GROUP,
  OTHER_EATING_PLACES_INDUSTRY_GROUP,
  OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
  OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
  OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
  OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
  OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
  OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
  OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
  OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
  OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
  OTHER_SCHOOLS_INDUSTRY_GROUP,
  OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
  OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
  OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
  OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
  OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
  OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
  OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
  OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
  PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
  PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
  PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
  PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
  PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
  PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
  PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
  PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
  PHYSICIANS_INDUSTRY_GROUP,
  PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
  POULTRY_AND_EGG_INDUSTRY_GROUP,
  PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
  PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
  PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
  PULP_PAPER_MILLS_INDUSTRY_GROUP,
  RADIO_AND_TELEVISION_INDUSTRY_GROUP,
  RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
  RECREATIONAL_CAMPS_INDUSTRY_GROUP,
  RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
  REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
  RESERVATION_SERVICES_INDUSTRY_GROUP,
  RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
  RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
  RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
  RUBBER_MANUFACTURING_INDUSTRY_GROUP,
  SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
  SCENIC_LAND_INDUSTRY_GROUP,
  SCENIC_OTHER_INDUSTRY_GROUP,
  SCENIC_WATER_INDUSTRY_GROUP,
  SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
  SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
  SEAFOOD_PREPARATION_INDUSTRY_GROUP,
  SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
  SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
  SHEEP_AND_GOAT_INDUSTRY_GROUP,
  SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
  SHOE_RETAILERS_INDUSTRY_GROUP,
  SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
  SOCIAL_ADVOCACY_INDUSTRY_GROUP,
  SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
  SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
  SOUND_INDUSTRY_GROUP,
  SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
  SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
  SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
  SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
  SPECTATOR_SPORTS_INDUSTRY_GROUP,
  SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
  SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
  STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
  SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
  SUGAR_MANUFACTURING_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
  SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP,
  SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
  SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
  TAXI_SERVICE_INDUSTRY_GROUP,
  TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
  TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
  TEXTILE_MILLS_INDUSTRY_GROUP,
  TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP,
  TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
  TRADE_SCHOOLS_INDUSTRY_GROUP,
  TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
  URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
  USED_MERCHANDISE_INDUSTRY_GROUP,
  UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
  VEGETABLE_AND_MELON_INDUSTRY_GROUP,
  VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
  VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
  VENEER_PLYWOOD_INDUSTRY_GROUP,
  VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
  VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
  WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
  WASTE_COLLECTION_INDUSTRY_GROUP,
  WASTE_DISPOSAL_INDUSTRY_GROUP,
  WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
  WORKERS_CAMPS_INDUSTRY_GROUP,
} from '../industryGroupOptions';
import { MANAGEMENT_OF_COMPANIES_SECTOR, SCIENTIFIC_SERVICES_SECTOR, UTILITIES_SECTOR } from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const INDUSTRY_GROUP_OPTIONS_ES = {
  [CROP_PRODUCTION_SUB_SECTOR]: [
    { value: OILSEED_AND_GRAIN_INDUSTRY_GROUP, label: 'Cultivo de oleaginosas y cereales' },
    { value: VEGETABLE_AND_MELON_INDUSTRY_GROUP, label: 'Cultivo de hortalizas y melones' },
    { value: FRUIT_AND_TREE_NUT_INDUSTRY_GROUP, label: 'Cultivo de frutas y frutos secos de árbol' },
    {
      value: GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
      label: 'Producción en invernaderos, viveros y floricultura',
    },
    { value: OTHER_CROP_FARMING_INDUSTRY_GROUP, label: 'Otros cultivos agrícolas' },
  ],

  [ANIMAL_AND_AGRICULTURE_SUB_SECTOR]: [
    { value: CATTLE_RANCHING_FARMING_INDUSTRY_GROUP, label: 'Ganadería bovina y explotación de ganado' },
    { value: HOD_AND_PIG_FARMING_INDUSTRY_GROUP, label: 'Cría de cerdos' },
    { value: POULTRY_AND_EGG_INDUSTRY_GROUP, label: 'Producción avícola y de huevos' },
    { value: SHEEP_AND_GOAT_INDUSTRY_GROUP, label: 'Cría de ovejas y cabras' },
    { value: AQUACULTURE_INDUSTRY_GROUP, label: 'Acuicultura' },
    { value: OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP, label: 'Otras actividades de producción animal' },
  ],
  [FORESTRY_AND_LOGGING_SUB_SECTOR]: [
    { value: TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP, label: 'Explotación de áreas forestales' },
    { value: FOREST_NURSERIES_INDUSTRY_GROUP, label: 'Viveros forestales y recolección de productos forestales' },
    { value: LOGGING_INDUSTRY_GROUP, label: 'Tala y explotación forestal' },
  ],

  [FISHING_HUNTING_TRAPPING_SUB_SECTOR]: [
    { value: FISHING_INDUSTRY_GROUP, label: 'Pesca' },
    { value: HUNTING_AND_TRAPPING_INDUSTRY_GROUP, label: 'Caza y captura de animales' },
  ],

  [AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    {
      value: SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
      label: 'Servicios de apoyo para la agricultura y la silvicultura',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP,
      label: 'Servicios de apoyo para la producción animal',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP,
      label: 'Servicios de apoyo para la silvicultura',
    },
  ],

  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [],

  [MINING_SUB_SECTOR]: [
    { value: COAL_MINING_INDUSTRY_GROUP, label: 'Minería del carbón' },
    { value: METAL_ORE_MINING_INDUSTRY_GROUP, label: 'Minería de minerales metálicos' },
    {
      value: NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
      label: 'Minería y extracción de minerales no metálicos',
    },
  ],

  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [],

  [UTILITIES_SECTOR]: [
    {
      value: ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
      label: 'Generación, transmisión y distribución de energía eléctrica',
    },
    {
      value: NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
      label: 'Distribución de gas natural',
    },
  ],

  [BUILDING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Construcción de edificios residenciales',
    },
    {
      value: NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Construcción de edificios no residenciales',
    },
  ],

  [HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Construcción de sistemas de infraestructura',
    },
    {
      value: LAND_SUBDIVISION_INDUSTRY_GROUP,
      label: 'Urbanización y parcelación de terrenos',
    },
    {
      value: HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Construcción de carreteras, calles y puentes',
    },
    {
      value: OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Otras obras de ingeniería civil y construcción pesada',
    },
  ],

  [SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR]: [
    {
      value: FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Contratistas de cimentación, estructuras y exteriores de edificios',
    },
    {
      value: BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Contratistas de instalaciones para edificios',
    },
    {
      value: BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Contratistas de acabados de edificios',
    },
    {
      value: OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
      label: 'Otros contratistas especializados',
    },
  ],

  [FOOD_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de alimentos para animales',
    },
    {
      value: GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP,
      label: 'Molienda de cereales y oleaginosas',
    },
    {
      value: SUGAR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de azúcar y productos de confitería',
    },
    {
      value: FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Conservación de frutas y hortalizas y fabricación de alimentos especializados',
    },
    {
      value: DAIRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos lácteos',
    },
    {
      value: ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
      label: 'Sacrificio y procesamiento de animales',
    },
    {
      value: SEAFOOD_PREPARATION_INDUSTRY_GROUP,
      label: 'Preparación y envasado de productos del mar',
    },
    {
      value: BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Panaderías y fabricación de tortillas',
    },
    {
      value: OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otras industrias alimentarias',
    },
  ],

  [BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR]: [
    {
      value: BEVERAGE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de bebidas',
    },
    {
      value: TOBACCO_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de tabaco',
    },
  ],

  [TEXTILE_MILLS_SUB_SECTOR]: [
    {
      value: FIBER_YARN_MILLS_INDUSTRY_GROUP,
      label: 'Fabricación de fibras, hilos e hilazas',
    },
    {
      value: FABRIC_MILLS_INDUSTRY_GROUP,
      label: 'Fabricación de tejidos',
    },
    {
      value: TEXTILE_MILLS_INDUSTRY_GROUP,
      label: 'Acabado y recubrimiento de textiles y tejidos',
    },
  ],

  [TEXTILE_PRODUCT_MILLS_SUB_SECTOR]: [
    {
      value: TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP,
      label: 'Fabricación de artículos textiles para el hogar',
    },
    {
      value: OTHER_TEXTILE_MILLS_INDUSTRY_GROUP,
      label: 'Otros productos textiles',
    },
  ],

  [APPAREL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: APPAREL_KNITTING_MILLS_INDUSTRY_GROUP,
      label: 'Fabricación de prendas de punto',
    },
    {
      value: CUT_AND_SEW_APPAREL_INDUSTRY_GROUP,
      label: 'Fabricación de prendas confeccionadas',
    },
    {
      value: APPAREL_ACCESSORIES_INDUSTRY_GROUP,
      label: 'Fabricación de accesorios y otros artículos de vestir',
    },
  ],

  [LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
      label: 'Curtido y acabado de cuero y pieles',
    },
    {
      value: FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de calzado',
    },
    {
      value: OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otros productos de cuero y materiales afines',
    },
  ],
  [WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
      label: 'Aserraderos y preservación de la madera',
    },
    {
      value: VENEER_PLYWOOD_INDUSTRY_GROUP,
      label: 'Fabricación de chapas, madera contrachapada y productos de madera de ingeniería',
    },
    {
      value: OTHER_WOOD_PRODUCT_INDUSTRY_GROUP,
      label: 'Otros productos de madera',
    },
  ],

  [PAPER_MANUFACTURING_SUB_SECTOR]: [
    {
      value: PULP_PAPER_MILLS_INDUSTRY_GROUP,
      label: 'Fabricación de pulpa, papel y cartón',
    },
    {
      value: CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de papel transformado',
    },
  ],

  [PRINTING_MANUFACTURING_SUB_SECTOR]: [],

  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [],

  [CHEMICAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos químicos básicos',
    },
    {
      value: RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de resinas, caucho sintético, fibras y filamentos artificiales y sintéticos',
    },
    {
      value: PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de pesticidas, fertilizantes y otros productos químicos agrícolas',
    },
    {
      value: PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos farmacéuticos y medicamentos',
    },
    {
      value: PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de pinturas, recubrimientos y adhesivos',
    },
    {
      value: SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de jabones, productos de limpieza y artículos de higiene personal',
    },
    {
      value: OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otros productos y preparados químicos',
    },
  ],

  [PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR]: [
    {
      value: PLASTIC_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos plásticos',
    },
    {
      value: RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de caucho',
    },
  ],

  [NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de arcilla y materiales refractarios',
    },
    {
      value: GLASS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de vidrio y productos de vidrio',
    },
    {
      value: CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de cemento y productos de hormigón',
    },
    {
      value: LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de cal y yeso',
    },
    {
      value: OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otros productos minerales no metálicos',
    },
  ],

  [PRIMARY_METAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
      label: 'Producción de hierro, acero y ferroaleaciones',
    },
    {
      value: STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos de acero a partir de acero adquirido',
    },
    {
      value: ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
      label: 'Producción y procesamiento de alúmina y aluminio',
    },
    {
      value: NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
      label: 'Producción y procesamiento de metales no ferrosos (excepto aluminio)',
    },
    {
      value: FOUNDRIES_INDUSTRY_GROUP,
      label: 'Fundiciones',
    },
  ],

  [FABRICATED_METAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: FORGING_AND_STAMPING_INDUSTRY_GROUP,
      label: 'Forja y estampado de metales',
    },
    {
      value: CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de cuchillería y herramientas manuales',
    },
    {
      value: ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de estructuras y componentes metálicos para la construcción',
    },
    {
      value: BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de calderas, tanques y contenedores de transporte',
    },
    {
      value: HARDWARE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de herrajes',
    },
    {
      value: SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de resortes y productos de alambre',
    },
    {
      value: MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Talleres de mecanizado y fabricación de tornillos, tuercas y pernos',
    },
    {
      value: COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
      label: 'Recubrimiento, grabado, tratamiento térmico y actividades relacionadas',
    },
    {
      value: OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otros productos metálicos fabricados',
    },
  ],

  [MACHINERY_MANUFACTURING_SUB_SECTOR]: [
    {
      value: AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de maquinaria agrícola, de construcción y minería',
    },
    {
      value: INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de maquinaria industrial',
    },
    {
      value: COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de maquinaria para los sectores comercial y de servicios',
    },
    {
      value: VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos de ventilación, calefacción, aire acondicionado y refrigeración comercial',
    },
    {
      value: METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de maquinaria para el trabajo de metales',
    },
    {
      value: ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de motores, turbinas y equipos de transmisión de potencia',
    },
    {
      value: OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de otra maquinaria de uso general',
    },
  ],

  [COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR]: [
    {
      value: COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de computadoras y equipos periféricos',
    },
    {
      value: COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos de comunicaciones',
    },
    {
      value: AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos de audio y video',
    },
    {
      value: SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de semiconductores y otros componentes electrónicos',
    },
    {
      value: NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
      label: 'Fabricación de instrumentos de navegación, medición, electromedicina y control',
    },
    {
      value: MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
      label: 'Fabricación y reproducción de soportes magnéticos y ópticos',
    },
  ],

  [ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos de iluminación eléctrica',
    },
    {
      value: HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de electrodomésticos',
    },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos eléctricos',
    },
    {
      value: OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de otros equipos y componentes eléctricos',
    },
  ],

  [TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de vehículos automotores',
    },
    {
      value: VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de carrocerías y remolques',
    },
    {
      value: VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de autopartes',
    },
    {
      value: AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de productos y componentes aeroespaciales',
    },
    {
      value: RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de material rodante ferroviario',
    },
    {
      value: SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
      label: 'Construcción naval y de embarcaciones',
    },
    {
      value: OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de otros equipos de transporte',
    },
  ],

  [FURNITURE_MANUFACTURING_SUB_SECTOR]: [
    {
      value: HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de muebles para el hogar, instituciones y gabinetes de cocina',
    },
    {
      value: OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de mobiliario de oficina (incluidos accesorios)',
    },
    {
      value: OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de otros productos relacionados con el mobiliario',
    },
  ],

  [MISCELLANEOUS_MANUFACTURING_SUB_SECTOR]: [
    {
      value: MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Fabricación de equipos y suministros médicos',
    },
    {
      value: OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Otras industrias manufactureras',
    },
  ],
  [DURABLE_GOODS_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de vehículos automotores, repuestos y suministros',
    },
    {
      value: FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de muebles y artículos para el hogar',
    },
    {
      value: LUMBER_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de madera y materiales de construcción',
    },
    {
      value: PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de equipos y suministros profesionales y comerciales',
    },
    {
      value: METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de metales y minerales (excepto petróleo)',
    },
    {
      value: HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de electrodomésticos y equipos eléctricos y electrónicos',
    },
    {
      value: HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de ferretería y equipos de fontanería y calefacción',
    },
    {
      value: MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de maquinaria, equipos y suministros',
    },
    {
      value: MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de otros bienes duraderos',
    },
  ],

  [NONDURABLE_GOODS_SUB_SECTOR]: [
    {
      value: PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de papel y productos de papel',
    },
    {
      value: DRUGS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de medicamentos y productos farmacéuticos',
    },
    {
      value: APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de prendas de vestir, textiles y mercería',
    },
    {
      value: GROCERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de alimentos y productos relacionados',
    },
    {
      value: FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de materias primas agrícolas',
    },
    {
      value: CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de productos químicos y afines',
    },
    {
      value: PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de petróleo y derivados',
    },
    {
      value: BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de cerveza, vino y bebidas alcohólicas destiladas',
    },
    {
      value: MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Comercio mayorista de otros bienes no duraderos',
    },
  ],

  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],

  [MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR]: [
    {
      value: AUTO_DEALERS_INDUSTRY_GROUP,
      label: 'Concesionarios de automóviles',
    },
    {
      value: OTHER_MOTOR_DEALERS_INDUSTRY_GROUP,
      label: 'Otros distribuidores de vehículos automotores',
    },
    {
      value: AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
      label: 'Minoristas de autopartes, accesorios y neumáticos',
    },
  ],

  [BUILDING_MATERIAL_DEALERS_SUB_SECTOR]: [
    {
      value: BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
      label: 'Minoristas de materiales y suministros para la construcción',
    },
    {
      value: LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
      label: 'Minoristas de equipos y suministros para jardín',
    },
  ],

  [FOOD_RETAILERS_SUB_SECTOR]: [
    {
      value: GROCERY_RETAILERS_INDUSTRY_GROUP,
      label: 'Supermercados y tiendas de conveniencia',
    },
    {
      value: SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas especializadas de alimentos',
    },
    {
      value: BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de cerveza, vino y bebidas alcohólicas',
    },
  ],

  [FURNITURE_RETAILERS_SUB_SECTOR]: [
    {
      value: FURNITURE_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de muebles y artículos para el hogar',
    },
    {
      value: ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de electrónica y electrodomésticos',
    },
  ],

  [MERCHANDISE_RETAILERS_SUB_SECTOR]: [
    {
      value: DEPARTMENT_STORE_INDUSTRY_GROUP,
      label: 'Grandes almacenes',
    },
    {
      value: WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
      label: 'Clubes mayoristas, hipermercados y otros comercios minoristas de mercancías generales',
    },
  ],

  [HEALTH_RETAILERS_SUB_SECTOR]: [],

  [GASOLINE_DEALERS_SUB_SECTOR]: [
    {
      value: GASOLINE_STATIONS_INDUSTRY_GROUP,
      label: 'Estaciones de servicio',
    },
    {
      value: FUEL_DEALERS_INDUSTRY_GROUP,
      label: 'Distribuidores de combustibles',
    },
  ],

  [CLOTHING_RETAILERS_SUB_SECTOR]: [
    {
      value: CLOTHING_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de ropa y accesorios',
    },
    {
      value: SHOE_RETAILERS_INDUSTRY_GROUP,
      label: 'Zapaterías',
    },
    {
      value: JEWELRY_RETAILERS_INDUSTRY_GROUP,
      label: 'Joyerías y tiendas de artículos de viaje y cuero',
    },
  ],

  [SPORTING_GOODS_RETAILERS_SUB_SECTOR]: [
    {
      value: SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de artículos deportivos, pasatiempos e instrumentos musicales',
    },
    {
      value: BOOK_RETAILERS_INDUSTRY_GROUP,
      label: 'Librerías y puestos de periódicos',
    },
    {
      value: FLORISTS_INDUSTRY_GROUP,
      label: 'Floristerías',
    },
    {
      value: OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
      label: 'Tiendas de material de oficina, papelería y regalos',
    },
    {
      value: USED_MERCHANDISE_INDUSTRY_GROUP,
      label: 'Tiendas de artículos de segunda mano',
    },
    {
      value: OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
      label: 'Otros comercios minoristas especializados',
    },
  ],

  [AIR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte aéreo regular',
    },
    {
      value: NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte aéreo no regular',
    },
  ],

  [RAIL_TRANSPORTATION_SUB_SECTOR]: [],

  [WATER_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte marítimo, costero y por los Grandes Lagos',
    },
    {
      value: INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte por vías navegables interiores',
    },
  ],

  [TRUCK_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP,
      label: 'Transporte general de carga por carretera',
    },
    {
      value: SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
      label: 'Transporte especializado de carga por carretera',
    },
  ],

  [TRANSIT_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP,
      label: 'Sistemas de transporte urbano',
    },
    {
      value: INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte interurbano y rural en autobús',
    },
    {
      value: TAXI_SERVICE_INDUSTRY_GROUP,
      label: 'Servicios de taxi y limusina',
    },
    {
      value: SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte escolar y de empleados',
    },
    {
      value: CHARTER_BUS_INDUSTRY_GROUP,
      label: 'Servicios de autobuses chárter',
    },
    {
      value: OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Otros servicios de transporte terrestre de pasajeros',
    },
  ],
  [PIPELINE_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte de petróleo crudo por oleoductos',
    },
    {
      value: NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Transporte de gas natural por gasoductos',
    },
    {
      value: OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Otros servicios de transporte por tuberías',
    },
  ],

  [SCENIC_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCENIC_LAND_INDUSTRY_GROUP,
      label: 'Transporte turístico terrestre',
    },
    {
      value: SCENIC_WATER_INDUSTRY_GROUP,
      label: 'Transporte turístico acuático',
    },
    {
      value: SCENIC_OTHER_INDUSTRY_GROUP,
      label: 'Otros servicios de transporte turístico',
    },
  ],

  [SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Servicios de apoyo al transporte aéreo',
    },
    {
      value: SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Servicios de apoyo al transporte ferroviario',
    },
    {
      value: SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Servicios de apoyo al transporte acuático',
    },
    {
      value: SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Servicios de apoyo al transporte por carretera',
    },
    {
      value: FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
      label: 'Servicios de gestión y coordinación del transporte de carga',
    },
    {
      value: OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Otros servicios de apoyo al transporte',
    },
  ],

  [POSTAL_SERVICE_SUB_SECTOR]: [],

  [COURIERS_SUB_SECTOR]: [
    {
      value: COURIER_DELIVERY_INDUSTRY_GROUP,
      label: 'Servicios de mensajería y entrega urgente',
    },
    {
      value: LOCAL_DELIVERY_INDUSTRY_GROUP,
      label: 'Mensajería y entregas locales',
    },
  ],

  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [],

  [MOTION_PIC_INDUSTRIES_SUB_SECTOR]: [
    {
      value: MOTION_PICTURE_INDUSTRY_GROUP,
      label: 'Industria cinematográfica y de producción de video',
    },
    {
      value: SOUND_INDUSTRY_GROUP,
      label: 'Industria de la grabación de sonido',
    },
  ],

  [PUBLISHING_INDUSTRIES_SUB_SECTOR]: [
    {
      value: NEWSPAPER_INDUSTRY_GROUP,
      label: 'Edición de periódicos, revistas, libros y directorios',
    },
    {
      value: SOFTWARE_PUBLISHERS_INDUSTRY_GROUP,
      label: 'Desarrollo y edición de software',
    },
  ],

  [BROADCASTING_PROVIDER_SUB_SECTOR]: [
    {
      value: RADIO_AND_TELEVISION_INDUSTRY_GROUP,
      label: 'Emisoras de radio y televisión',
    },
    {
      value: MEDIA_STREAMING_INDUSTRY_GROUP,
      label: 'Servicios de streaming, redes sociales y otras plataformas y proveedores de contenido digital',
    },
  ],

  [TELECOMMUNICATION_SUB_SECTOR]: [
    {
      value: WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Telecomunicaciones alámbricas e inalámbricas (excepto satelitales)',
    },
    {
      value: SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Telecomunicaciones por satélite',
    },
    {
      value: OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Otros servicios de telecomunicaciones',
    },
  ],

  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],

  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [],

  [MONETARY_BANK_SUB_SECTOR]: [],

  [CREDIT_INTERMEDIATION_SUB_SECTOR]: [
    {
      value: DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Intermediación crediticia mediante instituciones de depósito',
    },
    {
      value: NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Intermediación crediticia no bancaria',
    },
    {
      value: ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Servicios relacionados con la intermediación crediticia',
    },
  ],

  [SECURITIES_COMMODITY_SUB_SECTOR]: [
    {
      value: COMMODITY_CONTRACTS_INDUSTRY_GROUP,
      label: 'Intermediación y corretaje de valores y contratos sobre materias primas',
    },
    {
      value: COMMODITY_EXCHANGES_INDUSTRY_GROUP,
      label: 'Bolsas de valores y mercados de materias primas',
    },
    {
      value: OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
      label: 'Otras actividades de inversión financiera',
    },
  ],

  [INSURANCE_CARRIERS_SUB_SECTOR]: [
    {
      value: INSURANCE_CARRIER_INDUSTRY_GROUP,
      label: 'Compañías de seguros',
    },
    {
      value: AGENCIES_BROKERAGES_INDUSTRY_GROUP,
      label: 'Agencias, corredurías y otros servicios relacionados con seguros',
    },
  ],

  [FUNDS_TRUSTS_SUB_SECTOR]: [
    {
      value: INSURANCE_FUNDS_INDUSTRY_GROUP,
      label: 'Fondos de seguros y de prestaciones para empleados',
    },
    {
      value: OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
      label: 'Otros fondos y vehículos de inversión',
    },
  ],

  [REAL_ESTATE_SUB_SECTOR]: [
    {
      value: LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Arrendadores de bienes inmuebles',
    },
    {
      value: OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Agencias inmobiliarias y corredores de bienes raíces',
    },
    {
      value: ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Servicios relacionados con el sector inmobiliario',
    },
  ],

  [RENTAL_AND_LEASING_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
      label: 'Alquiler y arrendamiento de vehículos y equipos automotrices',
    },
    {
      value: CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
      label: 'Alquiler de bienes de consumo',
    },
    {
      value: GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
      label: 'Centros de alquiler general',
    },
    {
      value: COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
      label: 'Alquiler y arrendamiento de maquinaria y equipos comerciales e industriales',
    },
  ],

  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [SCIENTIFIC_SERVICES_SECTOR]: [
    {
      value: LEGAL_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios jurídicos',
    },
    {
      value: ACCOUNTING_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de contabilidad, preparación de impuestos, teneduría de libros y nóminas',
    },
    {
      value: ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de arquitectura, ingeniería y actividades relacionadas',
    },
    {
      value: DESIGN_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios especializados de diseño',
    },
    {
      value: COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
      label: 'Diseño de sistemas informáticos y servicios relacionados',
    },
    {
      value: TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de consultoría en gestión, ciencia y tecnología',
    },
    {
      value: SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de investigación y desarrollo científico',
    },
    {
      value: ADVERTISING_SERVICES_INDUSTRY_GROUP,
      label: 'Publicidad, relaciones públicas y servicios relacionados',
    },
    {
      value: OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
      label: 'Otros servicios profesionales, científicos y técnicos',
    },
  ],

  [ADMINISTRATIVE_SERVICE_SUB_SECTOR]: [
    {
      value: OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios administrativos de oficina',
    },
    {
      value: FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de apoyo a instalaciones',
    },
    {
      value: EMPLOYMENTS_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de empleo y contratación',
    },
    {
      value: BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de apoyo empresarial',
    },
    {
      value: RESERVATION_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de reservas y organización de viajes',
    },
    {
      value: INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de investigación y seguridad',
    },
    {
      value: SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
      label: 'Servicios para edificios y viviendas',
    },
    {
      value: OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Otros servicios de apoyo',
    },
  ],

  [WASTE_MANAGEMENT_SUB_SECTOR]: [
    {
      value: WASTE_COLLECTION_INDUSTRY_GROUP,
      label: 'Recolección de residuos',
    },
    {
      value: WASTE_DISPOSAL_INDUSTRY_GROUP,
      label: 'Tratamiento y eliminación de residuos',
    },
    {
      value: REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
      label: 'Remediación y otros servicios de gestión de residuos',
    },
  ],

  [EDUCATIONAL_SERVICES_SUB_SECTOR]: [
    {
      value: ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
      label: 'Educación primaria y secundaria',
    },
    {
      value: JUNIOR_COLLEGES_INDUSTRY_GROUP,
      label: 'Institutos de educación superior de ciclo corto',
    },
    {
      value: PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
      label: 'Universidades, instituciones de educación superior y escuelas profesionales',
    },
    {
      value: BUSINESS_SCHOOLS_INDUSTRY_GROUP,
      label: 'Escuelas de negocios y formación en informática y gestión',
    },
    {
      value: TRADE_SCHOOLS_INDUSTRY_GROUP,
      label: 'Escuelas técnicas y de formación profesional',
    },
    {
      value: OTHER_SCHOOLS_INDUSTRY_GROUP,
      label: 'Otros centros educativos y de formación',
    },
    {
      value: EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de apoyo educativo',
    },
  ],

  [AMBULATORY_CARE_SUB_SECTOR]: [
    {
      value: PHYSICIANS_INDUSTRY_GROUP,
      label: 'Consultorios médicos',
    },
    {
      value: DENTISTS_INDUSTRY_GROUP,
      label: 'Consultorios odontológicos',
    },
    {
      value: OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
      label: 'Consultorios de otros profesionales de la salud',
    },
    {
      value: OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
      label: 'Centros de atención ambulatoria',
    },
    {
      value: MEDICAL_LABS_INDUSTRY_GROUP,
      label: 'Laboratorios médicos y de diagnóstico',
    },
    {
      value: HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de atención médica a domicilio',
    },
    {
      value: OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
      label: 'Otros servicios de atención sanitaria ambulatoria',
    },
  ],

  [HOSPITALS_SUB_SECTOR]: [
    {
      value: GENERAL_MEDICAL_INDUSTRY_GROUP,
      label: 'Hospitales generales médicos y quirúrgicos',
    },
    {
      value: SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
      label: 'Hospitales psiquiátricos y de tratamiento de adicciones',
    },
    {
      value: SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
      label: 'Hospitales especializados (excepto psiquiátricos y de tratamiento de adicciones)',
    },
  ],

  [NURSING_FACILITIES_SUB_SECTOR]: [
    {
      value: NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
      label: 'Centros de atención y cuidados de enfermería',
    },
    {
      value: RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
      label:
        'Centros residenciales para personas con discapacidad intelectual, trastornos del desarrollo, salud mental y tratamiento de adicciones',
    },
    {
      value: RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
      label: 'Comunidades para personas mayores y centros de vida asistida',
    },
    {
      value: OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
      label: 'Otros centros de atención residencial',
    },
  ],

  [SOCIAL_ASSISTANCE_SUB_SECTOR]: [
    {
      value: INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios individuales y de apoyo familiar',
    },
    {
      value: OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios comunitarios de alimentación, vivienda y asistencia de emergencia',
    },
    {
      value: VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de rehabilitación profesional',
    },
    {
      value: CHILD_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de cuidado infantil',
    },
  ],
  [PERFORMING_ARTS_SUB_SECTOR]: [
    {
      value: PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
      label: 'Compañías de artes escénicas',
    },
    {
      value: SPECTATOR_SPORTS_INDUSTRY_GROUP,
      label: 'Deportes para espectadores',
    },
    {
      value: PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
      label: 'Promotores de espectáculos, eventos deportivos y actividades similares',
    },
    {
      value: ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
      label:
        'Agentes y representantes de artistas, deportistas, personalidades públicas y otros profesionales del entretenimiento',
    },
    {
      value: INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
      label: 'Artistas, escritores e intérpretes independientes',
    },
  ],

  [MUSEUMS_SUB_SECTOR]: [],

  [AMUSEMENT_INDUSTRY_SUB_SECTOR]: [
    {
      value: AMUSEMENT_PARKS_INDUSTRY_GROUP,
      label: 'Parques de atracciones y salas recreativas',
    },
    {
      value: GAMBLING_INDUSTRIES_INDUSTRY_GROUP,
      label: 'Industria del juego y las apuestas',
    },
    {
      value: OTHER_AMUSEMENT_INDUSTRY_GROUP,
      label: 'Otras actividades recreativas y de entretenimiento',
    },
  ],

  [ACCOMMODATION_SUB_SECTOR]: [
    {
      value: TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
      label: 'Alojamiento para viajeros',
    },
    {
      value: RECREATIONAL_CAMPS_INDUSTRY_GROUP,
      label: 'Parques para autocaravanas y campamentos recreativos',
    },
    {
      value: WORKERS_CAMPS_INDUSTRY_GROUP,
      label: 'Pensiones, residencias, dormitorios y alojamientos para trabajadores',
    },
  ],

  [FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR]: [
    {
      value: SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios especiales de alimentación',
    },
    {
      value: DRINKING_PLACES_INDUSTRY_GROUP,
      label: 'Bares y establecimientos de bebidas alcohólicas',
    },
    {
      value: OTHER_EATING_PLACES_INDUSTRY_GROUP,
      label: 'Restaurantes y otros establecimientos de comida',
    },
  ],

  [REPAIR_AND_MAINTENANCE_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
      label: 'Reparación y mantenimiento de vehículos automotores',
    },
    {
      value: ELECTRONICS_REPAIR_INDUSTRY_GROUP,
      label: 'Reparación y mantenimiento de equipos electrónicos y de precisión',
    },
    {
      value: COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
      label:
        'Reparación y mantenimiento de maquinaria y equipos comerciales e industriales (excepto automotrices y electrónicos)',
    },
    {
      value: PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
      label: 'Reparación y mantenimiento de bienes personales y del hogar',
    },
  ],

  [LAUNDRY_SERVICE_SUB_SECTOR]: [
    {
      value: PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios de cuidado personal',
    },
    {
      value: DEATH_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Servicios funerarios',
    },
    {
      value: LAUNDRY_SERVICES_INDUSTRY_GROUP,
      label: 'Tintorerías y servicios de lavandería',
    },
    {
      value: OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
      label: 'Otros servicios personales',
    },
  ],

  [RELIGIOUS_SUB_SECTOR]: [
    {
      value: RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Organizaciones religiosas',
    },
    {
      value: GRANTMAKING_INDUSTRY_GROUP,
      label: 'Fundaciones y organizaciones de concesión de subvenciones',
    },
    {
      value: SOCIAL_ADVOCACY_INDUSTRY_GROUP,
      label: 'Organizaciones de defensa y acción social',
    },
    {
      value: SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Organizaciones cívicas y sociales',
    },
    {
      value: BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
      label: 'Organizaciones empresariales, profesionales, sindicales, políticas y similares',
    },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
};
